import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form'; //, Controller, Control
//import user from '../../assets/Data/user.json';
//import { IUser } from '../../Types/models';
// import { signOut, updateUserAttributes, deleteUser as cognitoDeleteUser, UpdateUserAttributeOutput } from 'aws-amplify/auth';
import { useAuthContext } from '../../contexts/AuthContext';

import { getAgendaUser, updateAgendaUser, usersByUsername } from './queries';
import {AgendaUser, UpdateAgendaUserInput, UsersByUsernameQuery, UsersByUsernameQueryVariables } from '../../graphql/API';

import { useQuery, useMutation, useLazyQuery } from '@apollo/client';
import { DEFAULT_USER_IMAGE } from '../../config';

// import styles from './styles';
import CustomInput  from './CustomInput'; // CustomInput , { IEditableUser, IEditableUserField }
import { getUrl, remove, uploadData } from 'aws-amplify/storage';
import { v4 as uuidV4 } from 'uuid';
import UserImage from '../../components/UserImage';
import { GetAgendaUserQuery, GetAgendaUserQueryVariables, UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables } from '../../graphql/API';
import CustomRadio from './CustomRadio';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import Select from 'react-dropdown-select';
import { Input } from '@aws-amplify/ui-react';
import Sidebar from '../services/Sidebar/Sidebar';
import { FaArrowCircleLeft } from "react-icons/fa";
import { Toast, ToastContainer } from 'react-bootstrap';

export type IEditableUserField = 'username' | 'firstName' | 'lastName' | 'phoneNumber' | 'role' | 'type' | 'night' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday' | "language" | "hours"; // | 'website' | 'bio';
export type IEditableUser = Pick<AgendaUser, IEditableUserField>;

const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

const EditProfileScreen = () => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    const userId = AuthUserId;
    // I18N
    const { t } = useTranslation();
    // NAVIGATION
    const location = useLocation();
    const navigate = useNavigate();
    // TOAST
    const [showToast, setShowToast] = useState(false);
    const [toastStatus, setToastStatus] = useState("");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");
    // MODAL
    const [contentModal, setContentModal] = useState(null);
    const [linkModal, setLinkModal] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    // FILE
    const [file, setFile] = useState(null);
    const [selectedPhoto, setSelectedPhoto] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [selectedLangage, setSelectedLangage] = useState("");
    const [selectedHours, setSelectedHours] = useState(0);
    const [locale, setLocale] = useState("en");
    // i18n.locale = locale;
    const {control, handleSubmit, setValue, register, formState: { errors }} = useForm<IEditableUser>();
        // {
        // defaultValues: {
        //     name: user?.name,
        //     username: user?.username,
        //     website: user?.website || '',
        //     bio: user?.bio || '',
        // }
    // });

    const {data, loading, error, refetch} = 
        useQuery<GetAgendaUserQuery,GetAgendaUserQueryVariables>(getAgendaUser, 
            {variables: {userId: userId}});    
    
    const [getUserByUsername, {data: dataUsername, loading: loadingUsername, error: errorUsername}] = 
        useLazyQuery<UsersByUsernameQuery, UsersByUsernameQueryVariables>(usersByUsername);

    const user = data?.getAgendaUser;

    const [doUpdateUser, {loading: loadingUpdate, error: errorUpdate}] = 
        useMutation<UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables>(updateAgendaUser); //data: dataUpdate, 
    // const [doDeleteUser, {loading: loadingDelete, error: errorDelete}] = useMutation<UpdateUserMutation, UpdateUserMutationVariables>(updateUser);
    //const [doDeleteUser, {loading: loadingDelete, error: errorDelete}] = useMutation<DeleteUserMutation, DeleteUserMutationVariables>(deleteUser);

    useEffect(() => {
        if (location.state?.toastMessage) {
            setToastStatus(location.state.status);
            setToastTitle(location.state.title);
            setToastMessage(location.state.toastMessage);
            setShowToast(true);

            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state]);

    useEffect(() => {
        if (!user) return;
        if (!user.language) return;
        setLocale(user?.language);
        // if (user) {
        setValue('username', user.username);
        setValue('firstName', user.firstName);
        setValue('lastName', user.lastName);
        setValue('phoneNumber', user.phoneNumber);
        setValue('language', user.language);
        setValue('hours', user.hours);
        // setValue('role', user.role);
        // setValue('type', user.type);
        
        
        setValue('night', user.night);
        setValue('monday', user.monday);
        setValue('tuesday', user.tuesday);
        setValue('wednesday', user.wednesday);
        setValue('thursday', user.thursday);
        setValue('friday', user.friday);
        setValue('saturday', user.saturday);
        setValue('sunday', user.sunday);
        // };
    }, [user, setValue]);

    // we will remove ByUsername query
    const validateUsername = async (username: string) => {
        try {
            const response = await getUserByUsername({variables: {username}});
            //console.log('response: ', response);
            if (response.error) {
                alert('Failed to fetch username');
                return false;
            };
            const users = response.data?.usersByUsername?.items;
            if (users && users.length > 0 && users?.[0]?.userId != userId) {
                return false;
            };
        } catch(error) {
            alert('Failed to fetch username');
            return false;
        };
        return true;
    };
   
    const onSubmit = async (formData: IEditableUser) => {
        const input: UpdateAgendaUserInput = {userId: userId, ...formData};
        if (file) {
            input.image = await uploadMedia(file);
        };
        // console.log('formData', formData);
        if (user.username) {
            // if (await validateUsername(formData.username)){    
                // console.log('formData:', formData);
                // console.log(selectedLangage + " ... " + user?.language);
                if (file) {      
                    await doUpdateUser({variables: {input: {userId: userId, image: input.image, language: selectedLangage, hours: selectedHours, ...formData}}});
                    // RNRestart.restart(); // reload app
                } else {
                    
                    await doUpdateUser({variables: {input: {userId: userId, language: selectedLangage, hours: selectedHours, ...formData}}});
                    // console.log(selectedLangage + " ... " + user?.language);
                    if (selectedLangage != user?.language) {
                        // RNRestart.restart(); // relaod App
                    }
                }
                // navigation.popToTop();
                // navigation.goBack();
                // navigate(t('link.settings'));
                navigate(`/profile/${t('link.edit')}`, { state: { status: "bg-success", title: "", toastMessage: t('toast.editProfile') }});
                // window.location.reload();
            // };
        } else {
            alert(t('signup.waring') + " :" + t('profile.provideUsername'));
        }
    };

    // const confirmDelete = () => {
    //     Alert.alert("Are you Sure?", "Deleting your user's permanent", [
    //         {
    //             text: 'Cancel',
    //             style: 'cancel', // add style
    //         },
    //         {
    //             text: 'Yes, Delete',
    //             style: 'destructive', // add style
    //             onPress: startDeleting,
    //         },
    //     ])
    // };

    // const startDeleting = async () => {
    //     if (!user) {
    //         return;
    //     };
    //     // delete form DB
    //     await doDeleteUser({variables: {input: {id: userId, deleted: 1}}});
    //     //await doDeleteUser({variables: {input: {id: userId}}});
    //     //delete from COGNITO
    //     // try {
    //     //     await cognitoDeleteUser();
    //     // } catch (error) {
    //     //     console.log(error);
    //     // };
    //     // signOut();
    // };

    const uploadMedia = async (data: File) => {
        // try {
        //     if (user?.image) {
        //       await remove({ key: user?.image }); //, options: { accessLevel: 'protected' } });
        //     };
        // } catch (error) {
        //     Alert.alert("Failed to delete your avatar", (error as Error).message);
        // };
        try {
            // const fileName = `${uuidV4()}.${data.name.split('.').pop()}`;
            const uriParts = file.name.split('.');
            const extension = uriParts[uriParts.length - 1];
            const fileName = `${uuidV4()}.${extension}`;
            const name = file.name;
            const type = file.type;
            const key = `${user?.comId}/${user?.userId}/avatar/${fileName}`;
            const result = await uploadData({
                // key: fileName,//`${uuidV4()}.${extension}`,
                path: `public/${key}`,
                // name: file.name,
                data: file,
            }).result;
            // get the blob of the file
            // const response = await fetch(uri);
            // const blob = await response.blob();
            // const uriParts = uri.split('.');
            // const extension = uriParts[uriParts.length - 1];
            // const result = await uploadData({
            //     key: `${uuidV4()}.${extension}`,
            //     data: blob,
            //   }).result;
            // console.log(result.key);
            return key;
        } catch (error) {
            alert(t('profile.error_uploading_image') + " :" + (error as Error).message);
        };
    };

    // const onChangePicture = async (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = event.target.files?.[0];
    //     if (file) {
    //       setFile(file)
    //       setSelectedPhoto(file);
    //       console.log('Fichier sélectionné :', file);
    //     }
    // };
    const onChangePicture = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
          setFile(file);
          setSelectedPhoto(file);
          // Génère une URL pour afficher l'aperçu
          const url = URL.createObjectURL(file);
          setPreviewUrl(url);
        }
    };
    // const onChangePicture = async () => {
        // launchImageLibrary({mediaType: 'photo', maxWidth: 1024, maxHeight: 1024, quality: 0.9}, ({didCancel, errorCode, errorMessage, assets}) => { // {mediaType: 'photo', maxWidth: 1024, maxHeight: 1024, quality: 0.9}
        //     if (!didCancel && !errorCode && assets && assets.length > 0) {
        //         const file = assets[0];
        //         const MAX_FILE_SIZE = 1024 * 1024 * 5; // 5MB
        //         if ((assets[0].fileSize ?? 0) < MAX_FILE_SIZE) {
        //             setSelectedPhoto(assets[0]);
        //         } else {
        //             Alert.alert(i18n.t('profile.fileTooLargeTitle'), i18n.t('profile.fileTooLarge'));
        //         }
                
        //     };
        // });
        //setSelectedPhoto("https://notjustdev-dummy.s3.us-east-2.amazonaws.com/images/4.jpg");
    // };

    //Apollo
    if (loading) {
        return (
            <div className="spinnerContainer">
                <Spinner animation="border" role="status" className="spinner">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>   
            </div>
        )
    };
    if (error || errorUpdate ) { //|| errorDelete) {
        return (
            <div className="users-container flex-grow-1 p-3">
                <h3>Error fetching the user</h3>
                <p>{error?.message || "User not found"}</p>
                <Link to="" onClick={() => window.location.reload()}>Reload</Link>
            </div>
        );
    };

    const languageOptions = [
        { key: "en", value: t('profile.english') },
        { key: "fr", value: t('profile.french') },
    ]
    const hoursOptions = [
        { key: 0, value: t('profile.noWorkingHours') },
        { key: 10, value: t('profile.10Hours') },
        { key: 20, value: t('profile.20Hours') },
        { key: 30, value: t('profile.30Hours') },
        { key: 40, value: t('profile.40Hours') },
        { key: 50, value: t('profile.50Hours') },
        { key: 60, value: t('profile.60Hours') },
        { key: 70, value: t('profile.70Hours') },
        { key: 80, value: t('profile.80Hours') },
        { key: 90, value: t('profile.90Hours') }
    ];

// console.log('phoneNumber', user?.phoneNumber);
// console.log('file',file)
    return (
        <>
            <ToastContainer className="p-3 toastTop">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
                    { toastTitle != "" &&
                    <Toast.Header className={`text-center ${toastStatus}`}>
                        <strong className="mx-auto text-white-50  ">{toastTitle}</strong>
                    </Toast.Header>
                    }
                    <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}</strong></Toast.Body>
                </Toast>
            </ToastContainer>
            
            <div className="d-flex">
                <Sidebar user={user} />
                <div className="users-container flex-grow-1 p-3 ">
                    <FaArrowCircleLeft className="back-link" onClick={() => navigate(t('link.settings'))}/>

                    <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
                        <div className="bg-white p-4 d-flex flex-column align-items-center gap-3 rounded-4 shadow-sm hover:shadow-md">
                            <div className="form_wrapper m-0 m-auto">
                                { previewUrl
                                ? 
                                    <img src={previewUrl} alt="Aperçu" className="userImage_lg" style={{ maxWidth: '200px', borderRadius: '8px' }} />
                                : 
                                    <UserImage user={user} customClass="userImage_lg" />
                                }
                                {/* { file.uri ?
                                    <img src={file ? file.uri : DEFAULT_USER_IMAGE} />
                                :
                                    
                                    <UserImage user={user} />
                                } */}
                                <Input type="file" title={t('document.selectFile')} onChange={onChangePicture} className="mt-4 mb-4 form-control" /> 
                            
                                {/* onChange={handleFileChange} className="form-control" /> */}
                                {/* <Button style={{}} onClick={onChangePicture}>{t('profile.changePicture')}</Button> */}
                    
                                {/* <CustomInput 
                                    name="username" 
                                    control={control} 
                                    rules={{required: "Username is required", minLength: { value: 4, message: "Name should have more then 3 characters"}}} 
                                    label="Username"
                                /> */}
                                {/* <CustomInput 
                                    name="username" 
                                    control={control} 
                                    rules={{required: "Userame is required", 
                                            minLength: { 
                                                value: 4, 
                                                message: "Username should have more then 3 characters"
                                            },
                                            //validate: validateUsername,    
                                    }} 
                                    label="Username"
                                /> */}
                                {/* <div style={{marginTop: 20, marginBottom: 10}}>
                                    <p style={{}}>{t('profile.username')}</p>
                                    <p>{user?.username}</p>
                                </div> */}
                                {/* <input type="text" title="username" name="username" className="form-control" /> */}

                                {/* <CustomInput 
                                    name="username" 
                                    control={control} 
                                    rules={{required: t('profile.usernameRequired'), minLength: { value: 4, message: t('profile.usernameRequiredMessage')}}} 
                                    label={t('profile.username')}
                                    startPlaceholder={t('profile.startPlaceholder')}
                                /> */}
                                
                                <CustomInput 
                                    name="firstName" 
                                    control={control} 
                                    rules={{required: t('profile.firstnameRequired'), minLength: { value: 4, message: t('profile.firstnameRequiredMessage')}}} 
                                    label={t('profile.firstname')}
                                    startPlaceholder={t('profile.startPlaceholder')}
                                />
                                <CustomInput 
                                    name="lastName" 
                                    control={control} 
                                    rules={{required: t('profile.lastnameRequired'), minLength: { value: 4, message: t('profile.lastnameRequiredMessage')}}} 
                                    label={t('profile.lastname')}
                                    startPlaceholder={t('profile.startPlaceholder')}
                                />         
                                <CustomInput 
                                    name="phoneNumber" 
                                    control={control} 
                                    // rules={{required: "Last Name is required", minLength: { value: 4, message: "Last Name should have more then 3 characters"}}} 
                                    label={t('profile.phoneNumber')}
                                    startPlaceholder={t('profile.startPlaceholder')}
                                />
                                <div>
                                    <p className="form-label">{t('profile.preferences')}</p>
                                </div>

                                <div className="d-flex flex-column align-items-start w-100">
                                    <p className="form-label text-start ms-0">{t('profile.language')}</p>
                                </div>
                                <Controller
                                    name="language"
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <Form.Select
                                        aria-label="language"
                                        className="d-inline me-lg-2 mb-4"
                                        value={value ?? ''}            // ← valeur contrôlée
                                        onChange={e => onChange(e.target.value)}
                                        >
                                        {/* <option value="">-- Sélectionnez --</option> */}
                                        {languageOptions.map(option => (
                                            <option key={option.key} value={option.key}>
                                            {option.value}
                                            </option>
                                        ))}
                                        </Form.Select>
                                    )}
                                />
                                {/* <InputGroup>
                                    <Form.Select
                                        aria-label="language"
                                        className="d-inline me-lg-2"
                                        {...register("language")} 
                                        name="language"
                                        >
                                        <option value="">-- Sélectionnez --</option>
                                        {languageOptions.map((option) => (
                                            <option key={option.key} value={option.key}>
                                                {option.value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </InputGroup> */}
                                {/* <SelectList
                                    setSelected={(val: any) => setSelectedLangage(val)}
                                    data={languageOptions}
                                    placeholder="Select Your Langage"
                                    boxStyles={{width:'100%', marginVertical: 5}}
                                    search={false}
                                    defaultOption={languageOptions.find(option => option.key === user?.language)}
                                    dropdownStyles={{
                                        backgroundColor: "white",
                                        // position: "absolute",
                                        // top: 40,
                                        width: "auto",
                                        zIndex: 999,
                                    }}
                                /> */}
                                <div className="d-flex flex-column align-items-start w-100">
                                    <p className="form-label text-start ms-0">{t('profile.availabilities')}</p>
                                </div>
                                <Controller
                                    name="hours"
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <Form.Select
                                        aria-label="hours"
                                        className="d-inline me-lg-2 mb-4"
                                        value={value ?? ''}            // ← valeur contrôlée
                                        onChange={e => onChange(e.target.value)}
                                        >
                                        {/* <option value="">-- Sélectionnez --</option> */}
                                        {hoursOptions.map((option) => (
                                            <option key={option.key} value={option.key}>
                                                {option.value}
                                            </option>
                                        ))}
                                        </Form.Select>
                                    )}
                                />
                                {/* <InputGroup>
                                    <Form.Select
                                        aria-label="hours"
                                        className="d-inline me-lg-2"
                                        {...register("hours")} 
                                        name="hours"
                                        >
                                        <option value="">-- Sélectionnez --</option>
                                        {hoursOptions.map((option) => (
                                            <option key={option.key} value={option.key}>
                                                {option.value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </InputGroup> */}
                                {/* <SelectList
                                    setSelected={(val: any) => setSelectedHours(val)}
                                    data={hoursOptions}
                                    placeholder="Select The Expecting Work Hours Per Week"
                                    boxStyles={{width:'100%', marginVertical: 5}}
                                    search={false}
                                    defaultOption={hoursOptions.find(option => option.key === user?.hours)}
                                    dropdownStyles={{
                                        backgroundColor: "white",
                                        // position: "absolute",
                                        // top: 40,
                                        width: "auto",
                                        zIndex: 999,
                                    }}
                                /> */}
                                {/* <MultipleSelectList 
                                    setSelected={(val: any) => setSelectedLangage(val)} 
                                    data={["en","fr"]} 
                                    save="key" // "value"
                                    placeholder="Select Langage"
                                    label="Select Langage"
                                    
                                    dropdownStyles={{
                                        backgroundColor: "white",
                                        // position: "absolute",
                                        // top: 40,
                                        width: "auto",
                                        zIndex: 999,
                                    }}
                                    // onSelect={(key: any) => setSelectedUsers(key)}
                                    // setSelected={setSelectedUser} 
                                    // fontFamily='lato'
                                    // // data={data}  
                                    arrowicon={<FontAwesome name="chevron-down" size={12} color={'black'} />} 
                                    searchicon={<FontAwesome name="search" size={12} color={'black'} />} 
                                    // search={false} 
                                    boxStyles={{borderRadius:0, width:'100%', marginVertical: 5}} //override default styles
                                    // defaultOption={{ key:'1', value:'Jammu & Kashmir' }}
                                /> */}
                                <div>
                                    <p className="form-label mb-4">{t('profile.availabilities')}</p>
                                </div>
                                <Row className="inputRadioContainer" >
                                    <Col>
                                        <CustomRadio name="night" control={control} label={t('profile.night')} />
                                        <CustomRadio name="monday" control={control} label={t('profile.monday')} />
                                        <CustomRadio name="tuesday" control={control} label={t('profile.tuesday')} />
                                        <CustomRadio name="wednesday" control={control} label={t('profile.wednesday')} />
                                    </Col>
                                    
                                    <Col>
                                        <CustomRadio name="thursday" control={control} label={t('profile.thursday')} />
                                        <CustomRadio name="friday" control={control} label={t('profile.friday')} />
                                        <CustomRadio name="saturday" control={control} label={t('profile.saturday')} />
                                        <CustomRadio name="sunday" control={control} label={t('profile.sunday')} />
                                    </Col>
                                    
                                </Row>

                                {/* <CheckboxField label="Role" name="Monday">
                                    <Checkbox name="role" value="true" label="Monday" />
                                    <Checkbox name="role" value="user" label="User" />
                                </CheckboxField> */}
                                {/* <Text>{user?.username}</Text> */}
                                {/* <CustomInput 
                                    name="website" 
                                    control={control} 
                                    rules={{
                                        //required: "Website is required",
                                        pattern: {value: URL_REGEX, message: "Your URL is not valid, ex: http://www.example.com"},
                                        //minLength: { value: 4, message: "Name should have more then 3 characters"}
                                    }} 
                                    label="Website"
                                /> */}
                                {/* <CustomInput 
                                    name="bio" 
                                    control={control} 
                                    rules={{
                                        //required: "Biography is required", 
                                        maxLength: { value: 201, message: "Name should have less then 200 characters"}
                                    }} 
                                    label="Biography"
                                    multiline={true}
                                /> */}
                                <Button type="submit" style={{}} >{loadingUpdate ? t('profile.submitting') : t('profile.submit')}</Button>
                                {/* <Button type="submit" style={{}} onClick={handleSubmit(onSubmit)}>{loadingUpdate ? t('profile.submitting') : t('profile.submit')}</Button> */}
                                {/* <Text style={styles.textButtonDanger} onPress={handleSubmit(confirmDelete)}>{loadingDelete ? 'Deleting...' : 'DELETE USER'}</Text> */}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
};

export default EditProfileScreen;